import React from "react"
import { useLanguageSelector } from "./hooks/useLanguageSelector"
import LanguageSelectorUI from "./LanguageSelector.ui"

export const LanguageSelectorView = () => {
  const {
    currentLanguageName,
    languages,
    open,
    anchorEl,
    handleOpen,
    handleClose,
    handleSelectLanguage,
  } = useLanguageSelector()

  return (
    <LanguageSelectorUI
      currentLanguageName={currentLanguageName}
      languages={languages}
      open={open}
      anchorEl={anchorEl}
      onOpen={handleOpen}
      onClose={handleClose}
      onSelectLanguage={handleSelectLanguage}
    />
  )
}
